import React, { useState, useEffect } from 'react';
import axios from '../utils/axiosInstance';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { getApiBase } from "../utils/useApiBase";

const UrugoUmuryango = () => {
  // Initial form data structure
  const initialFormData = {
    umudugudu: '',
    isibo: '',
    nimero_urugo: '',
    amazina_umukuru: '',
    uburyo_bwinzu: 'Iyabo',
    umubare_abagize: 0,
    abana_bari_murugo: 0,
    abageze_mu_zabukuru: 0,
    abafite_ubumuga: 0,
    icyiciro_ubudehe: '',
    icyiciro_imibereho: 'Arakennye',
    ahabwa_inkunga: '',
    ubwishingizi_ubuzima: '',
    abagore_batwite: 0,
    abana_bakingiwe: 0,
    hari_indwara_zidakira: false,
    hari_amakimbirane: false,
    yitabira_amarondo: false,
    yemeye_amakuru: false,
    umukono_cyangwa_igikumwe: ''
  };

  const [formData, setFormData] = useState(initialFormData);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeSection, setActiveSection] = useState('form');
  const [expandedRow, setExpandedRow] = useState(null);
  const [detailRecord, setDetailRecord] = useState(null);
  const [editId, setEditId] = useState(null);

  // Fetch data on component mount
  useEffect(() => {
    fetchHouseholds();
  }, []);

  // Auto-clear success message
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  // Auto-clear error message
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(null), 6000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  // Fetch all households
  const fetchHouseholds = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${getApiBase()}/urugo_umuryango`);
      setRecords(response.data || []);
    } catch (err) {
      console.error('Fetch error:', err);
      setError(typeof err.response?.data?.error === 'string' ? err.response.data.error : 'Ntibishoboka gusoma amakuru');
    } finally {
      setLoading(false);
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Handle form submission (Create/Update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!formData.yemeye_amakuru) {
      setError('Ugomba kwemeza amakuru mbere yo gukomeza');
      return;
    }

    setLoading(true);
    try {
      if (editId) {
        await axios.put(`/urugo_umuryango/${editId}`, formData);
        setSuccess('✅ Urugo ruvuguruwe neza!');
        setEditId(null);
      } else {
        await axios.post('/urugo_umuryango', formData);
        setSuccess('✅ Urugo rwanditswe neza!');
      }
      setFormData(initialFormData);
      await fetchHouseholds();
      setActiveSection('records');
    } catch (err) {
      console.error('Submit error:', err);
      setError(typeof err.response?.data?.error === 'string' ? err.response.data.error : 'Ntibishoboka kubika amakuru');
    } finally {
      setLoading(false);
    }
  };

  // Handle edit button click
  const handleEdit = (record) => {
    console.log('Editing record:', record);
    
    setFormData({
      umudugudu: record.umudugudu || '',
      isibo: record.isibo || '',
      nimero_urugo: record.nimero_urugo || '',
      amazina_umukuru: record.amazina_umukuru || '',
      uburyo_bwinzu: record.uburyo_bwinzu || 'Iyabo',
      umubare_abagize: record.umubare_abagize || 0,
      abana_bari_murugo: record.abana_bari_murugo || 0,
      abageze_mu_zabukuru: record.abageze_mu_zabukuru || 0,
      abafite_ubumuga: record.abafite_ubumuga || 0,
      icyiciro_ubudehe: record.icyiciro_ubudehe || '',
      icyiciro_imibereho: record.icyiciro_imibereho || 'Arakennye',
      ahabwa_inkunga: record.ahabwa_inkunga || '',
      ubwishingizi_ubuzima: record.ubwishingizi_ubuzima || '',
      abagore_batwite: record.abagore_batwite || 0,
      abana_bakingiwe: record.abana_bakingiwe || 0,
      hari_indwara_zidakira: Boolean(record.hari_indwara_zidakira),
      hari_amakimbirane: Boolean(record.hari_amakimbirane),
      yitabira_amarondo: Boolean(record.yitabira_amarondo),
      yemeye_amakuru: Boolean(record.yemeye_amakuru),
      umukono_cyangwa_igikumwe: record.umukono_cyangwa_igikumwe || ''
    });
    
    setEditId(record.id);
    setActiveSection('form');
    setDetailRecord(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Handle delete button click
  const handleDelete = async (id) => {
    if (!window.confirm('Uremeza ko ushaka gusiba uru rugo?')) return;
    
    try {
      setLoading(true);
      await axios.delete(`/urugo_umuryango/${id}`);
      
      setSuccess('🗑️ Urugo rwasibwe neza!');
      await fetchHouseholds();
      
      if (detailRecord?.id === id) {
        setDetailRecord(null);
      }
    } catch (err) {
      console.error('Delete error:', err);
      setError(typeof err.response?.data?.error === 'string' ? err.response.data.error : 'Ntibishoboka gusiba');
    } finally {
      setLoading(false);
    }
  };

  // Filter records based on search term
  const filteredRecords = records.filter(r =>
    r.nimero_urugo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    r.amazina_umukuru?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    r.umudugudu?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    r.isibo?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Boolean display helper
  const boolLabel = (val) => val ? '✅ Yego' : '❌ Oya';

  // Detail field component
  const DetailField = ({ icon, label, value, color }) => (
    <div className="ug-detail-item">
      <div className="ug-detail-lbl">
        <i className={`bi bi-${icon}`} style={{ color: color || '#64748b', marginRight: 5 }}></i>
        {label}
      </div>
      <div className="ug-detail-val">{value || '—'}</div>
    </div>
  );

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700;800;900&display=swap');

        .ug-root *, .ug-root *::before, .ug-root *::after {
          box-sizing: border-box; margin: 0; padding: 0;
          font-family: 'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          -webkit-tap-highlight-color: transparent;
        }
        .ug-root { -webkit-font-smoothing: antialiased; }
        .ug-root ::-webkit-scrollbar { width: 5px; height: 5px; }
        .ug-root ::-webkit-scrollbar-track { background: transparent; }
        .ug-root ::-webkit-scrollbar-thumb { background: rgba(11,61,145,0.2); border-radius: 10px; }

        @keyframes ugUp { from { opacity:0; transform:translateY(18px); } to { opacity:1; transform:translateY(0); } }
        @keyframes ugScale { from { opacity:0; transform:scale(0.94); } to { opacity:1; transform:scale(1); } }
        @keyframes ugSlide { from { opacity:0; transform:translateX(-12px); } to { opacity:1; transform:translateX(0); } }
        @keyframes ugPop {
          0% { opacity:0; transform:translateY(-10px) scale(0.94); }
          60% { transform:translateY(2px) scale(1.01); }
          100% { opacity:1; transform:translateY(0) scale(1); }
        }
        @keyframes ugGrad { 0%,100% { background-position:0% 50%; } 50% { background-position:100% 50%; } }
        @keyframes ugDot { 0%,80%,100% { transform:scale(0); } 40% { transform:scale(1); } }
        @keyframes ugFloat { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-5px); } }
        @keyframes ugCount { from { opacity:0; transform:translateY(5px); } to { opacity:1; transform:translateY(0); } }

        .ug-app {
          min-height: 100vh; min-height: 100dvh;
          background: #ffffff; color: #0d1b2a;
          position: relative; overflow-x: hidden;
        }
        .ug-app::before {
          content: ''; position: fixed; inset: 0;
          background:
            radial-gradient(ellipse 60% 40% at 15% 10%, rgba(11,61,145,0.06) 0%, transparent 50%),
            radial-gradient(ellipse 45% 55% at 85% 85%, rgba(11,61,145,0.04) 0%, transparent 45%);
          pointer-events: none; z-index: 0;
        }
        .ug-layer { position: relative; z-index: 1; }
        .ug-wrap { max-width: 1400px; margin: 0 auto; padding: 20px 16px 40px; }

        /* HEADER */
        .ug-header { text-align: center; margin-bottom: 28px; animation: ugUp 0.5s ease; }
        .ug-chip {
          display: inline-flex; align-items: center; gap: 6px;
          padding: 5px 14px; border-radius: 10px;
          background: rgba(11,61,145,0.08); border: 1px solid rgba(11,61,145,0.16);
          color: #0B3D91; font-size: 0.66rem; font-weight: 700;
          letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 12px;
        }
        .ug-title {
          font-size: clamp(1.4rem, 5vw, 2.4rem); font-weight: 900; line-height: 1.08; margin-bottom: 6px;
          background: linear-gradient(135deg, #0B3D91, #0B3D91, #0B3D91, #0B3D91);
          background-size: 300% 300%; animation: ugGrad 7s ease infinite;
          -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
        }
        .ug-sub { color: #64748b; font-size: clamp(0.82rem, 2vw, 0.95rem); max-width: 460px; margin: 0 auto; }

        /* STATS */
        .ug-stats {
          display: grid; grid-template-columns: repeat(4, 1fr);
          gap: 10px; margin-bottom: 24px; animation: ugUp 0.6s ease;
        }
        .ug-stat {
          background: linear-gradient(150deg, #ffffff, #f0f4fb);
          border: 1px solid #e2e8f0; border-radius: 16px;
          box-shadow: 0 6px 20px rgba(11,61,145,0.06);
          padding: 16px 10px; text-align: center;
          transition: all 0.4s cubic-bezier(0.25,0.46,0.45,0.94);
          position: relative; overflow: hidden; cursor: default;
        }
        .ug-stat::after {
          content: ''; position: absolute; top: 0; left: 0; right: 0;
          height: 2.5px; border-radius: 16px 16px 0 0; opacity: 0; transition: opacity 0.35s;
        }
        .ug-stat:hover { transform: translateY(-4px); border-color: rgba(11,61,145,0.07); }
        .ug-stat:hover::after { opacity: 1; }
        .ug-stat.c1::after { background: linear-gradient(90deg, #0B3D91, #0B3D91); }
        .ug-stat.c1:hover { box-shadow: 0 12px 36px rgba(11,61,145,0.1); }
        .ug-stat.c2::after { background: linear-gradient(90deg, #0369a1, #0369a1); }
        .ug-stat.c2:hover { box-shadow: 0 12px 36px rgba(3,105,161,0.1); }
        .ug-stat.c3::after { background: linear-gradient(90deg, #d97706, #d97706); }
        .ug-stat.c3:hover { box-shadow: 0 12px 36px rgba(217,119,6,0.08); }
        .ug-stat.c4::after { background: linear-gradient(90deg, #dc2626, #dc2626); }
        .ug-stat.c4:hover { box-shadow: 0 12px 36px rgba(220,38,38,0.08); }

        .ug-stat-ic {
          width: 38px; height: 38px; border-radius: 11px;
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 1rem; margin-bottom: 8px; transition: transform 0.35s;
        }
        .ug-stat:hover .ug-stat-ic { transform: scale(1.1) rotate(-4deg); }
        .ug-stat-v {
          font-size: clamp(1.3rem, 2.5vw, 1.8rem); font-weight: 800; color: #0d1b2a;
          line-height: 1; margin-bottom: 2px; animation: ugCount 0.5s ease;
        }
        .ug-stat-l { font-size: 0.56rem; color: #64748b; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; }

        /* TOGGLE */
        .ug-toggle-wrap { display: flex; justify-content: center; margin-bottom: 24px; animation: ugUp 0.7s ease; }
        .ug-toggle {
          display: flex; gap: 3px; padding: 4px; border-radius: 14px;
          background: #eef3fb; border: 1px solid #e2e8f0;
        }
        .ug-toggle-btn {
          padding: 10px 22px; border: none; border-radius: 11px;
          font-weight: 600; font-size: 0.82rem; cursor: pointer;
          display: flex; align-items: center; gap: 7px;
          transition: all 0.3s ease; white-space: nowrap; font-family: inherit;
        }
        .ug-toggle-btn.active {
          background: linear-gradient(135deg, #0B3D91, #093278); color: #ffffff;
          box-shadow: 0 3px 14px rgba(11,61,145,0.35);
        }
        .ug-toggle-btn:not(.active) { background: transparent; color: #64748b; }
        .ug-toggle-btn:not(.active):hover { color: #0B3D91; background: rgba(11,61,145,0.05); }
        .ug-badge {
          display: inline-flex; align-items: center; justify-content: center;
          min-width: 24px; height: 22px; padding: 0 6px; border-radius: 7px;
          background: rgba(11,61,145,0.15); color: #0B3D91; font-size: 0.72rem; font-weight: 700;
        }

        /* ALERT */
        .ug-alert {
          padding: 12px 16px; border-radius: 14px; display: flex; align-items: center;
          gap: 10px; font-weight: 500; font-size: 0.84rem; margin-bottom: 18px;
          animation: ugPop 0.4s cubic-bezier(0.34,1.56,0.64,1); border: 1px solid;
        }
        .ug-alert-ok { background: rgba(22,163,74,0.06); border-color: rgba(22,163,74,0.15); color: #16a34a; }
        .ug-alert-err { background: rgba(220,38,38,0.06); border-color: rgba(220,38,38,0.15); color: #dc2626; }
        .ug-alert-ic { width: 32px; height: 32px; min-width: 32px; border-radius: 9px; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; }
        .ug-alert-x { margin-left: auto; background: none; border: none; color: inherit; cursor: pointer; padding: 3px; opacity: 0.5; font-size: 0.8rem; }

        /* GLASS PANEL */
        .ug-glass {
          background: linear-gradient(145deg, #ffffff, #f7f9fc);
          border: 1px solid #e2e8f0; border-radius: 20px;
          box-shadow: 0 10px 32px rgba(11,61,145,0.06);
          transition: border-color 0.4s, box-shadow 0.4s; overflow: hidden;
        }
        .ug-glass:hover { border-color: rgba(11,61,145,0.15); }
        .ug-glass-body { padding: clamp(16px, 3.5vw, 36px); }

        /* FORM */
        .ug-section { display: flex; align-items: center; gap: 10px; margin-bottom: 18px; padding-bottom: 12px; border-bottom: 1px solid rgba(11,61,145,0.04); }
        .ug-section-dot { width: 32px; height: 32px; border-radius: 9px; display: flex; align-items: center; justify-content: center; font-size: 0.85rem; flex-shrink: 0; }
        .ug-section-txt { font-size: 0.72rem; font-weight: 700; color: rgba(11,61,145,0.55); text-transform: uppercase; letter-spacing: 0.08em; }

        .ug-grid { display: grid; gap: 12px; margin-bottom: 24px; }
        .ug-g2 { grid-template-columns: repeat(2, 1fr); }
        .ug-g3 { grid-template-columns: repeat(3, 1fr); }
        .ug-g4 { grid-template-columns: repeat(4, 1fr); }

        .ug-field { position: relative; }
        .ug-label { display: block; font-size: 0.66rem; font-weight: 650; color: #64748b; margin-bottom: 5px; text-transform: uppercase; letter-spacing: 0.06em; transition: color 0.3s; }
        .ug-field:focus-within .ug-label { color: #0B3D91; }
        .ug-req { color: #dc2626; margin-left: 2px; }
        .ug-iw { position: relative; }
        .ug-ii { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #94a3b8; font-size: 0.85rem; transition: color 0.3s; z-index: 2; pointer-events: none; }
        .ug-field:focus-within .ug-ii { color: #0B3D91; }
        .ug-inp {
          width: 100%; padding: 11px 12px 11px 36px;
          background: rgba(240,244,251,0.5); border: 1.5px solid rgba(11,61,145,0.055);
          border-radius: 11px; color: #0d1b2a; font-size: 0.86rem; font-weight: 500;
          outline: none; transition: all 0.3s; font-family: inherit;
          -webkit-appearance: none; appearance: none;
        }
        .ug-inp.ni { padding-left: 12px; }
        .ug-inp::placeholder { color: #94a3b8; }
        .ug-inp:focus { border-color: #0B3D91; background: #ffffff; box-shadow: 0 0 0 3px rgba(11,61,145,0.08); }
        .ug-sel {
          width: 100%; padding: 11px 32px 11px 36px;
          background: rgba(240,244,251,0.5); border: 1.5px solid rgba(11,61,145,0.055);
          border-radius: 11px; color: #0d1b2a; font-size: 0.86rem; font-weight: 500;
          outline: none; transition: all 0.3s; cursor: pointer; font-family: inherit;
          -webkit-appearance: none; appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='rgba(11,61,145,0.28)' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
          background-repeat: no-repeat; background-position: right 12px center;
        }
        .ug-sel:focus { border-color: #0B3D91; box-shadow: 0 0 0 3px rgba(11,61,145,0.08); }
        .ug-sel option { background: #ffffff; color: #0d1b2a; }

        .ug-chk {
          display: flex; align-items: center; gap: 10px;
          padding: 12px 14px; background: rgba(240,244,251,0.4);
          border: 1.5px solid rgba(11,61,145,0.04); border-radius: 11px;
          cursor: pointer; transition: all 0.3s; user-select: none;
        }
        .ug-chk:hover { border-color: rgba(11,61,145,0.15); background: rgba(11,61,145,0.04); }
        .ug-chk input { position: absolute; opacity: 0; width: 0; height: 0; }
        .ug-chk-box {
          width: 20px; height: 20px; min-width: 20px; border-radius: 6px;
          border: 2px solid rgba(11,61,145,0.18); background: rgba(240,244,251,0.5);
          display: flex; align-items: center; justify-content: center;
          transition: all 0.25s; font-size: 0.6rem; color: transparent;
        }
        .ug-chk input:checked + .ug-chk-box {
          background: linear-gradient(135deg, #0B3D91, #093278);
          border-color: #0B3D91; box-shadow: 0 2px 8px rgba(11,61,145,0.3);
          color: #ffffff;
        }
        .ug-chk-txt { font-size: 0.8rem; color: #64748b; font-weight: 500; }
        .ug-chk:has(input:checked) .ug-chk-txt { color: rgba(11,61,145,0.85); }
        .ug-chk:has(input:checked) { border-color: rgba(11,61,145,0.18); background: rgba(11,61,145,0.03); }

        .ug-btn-row { display: flex; gap: 10px; padding-top: 16px; border-top: 1px solid rgba(11,61,145,0.04); }
        .ug-btn {
          padding: 12px 28px; border-radius: 12px; font-weight: 650; font-size: 0.86rem;
          font-family: inherit; cursor: pointer; transition: all 0.3s; display: inline-flex;
          align-items: center; gap: 8px; border: none; white-space: nowrap;
        }
        .ug-btn-p {
          background: linear-gradient(135deg, #0B3D91, #093278); color: #ffffff;
          box-shadow: 0 3px 14px rgba(11,61,145,0.22);
        }
        .ug-btn-p:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(11,61,145,0.38); }
        .ug-btn-p:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
        .ug-btn-g {
          background: transparent; color: #64748b;
          border: 1.5px solid #e2e8f0 !important;
        }
        .ug-btn-g:hover { color: #0d1b2a; border-color: #0B3D91 !important; }
        .ug-btn-d {
          background: rgba(220,38,38,0.08); color: #dc2626;
          border: 1.5px solid rgba(220,38,38,0.15) !important;
        }
        .ug-btn-d:hover { background: rgba(220,38,38,0.14); }

        /* SEARCH */
        .ug-search-w { position: relative; max-width: 380px; width: 100%; }
        .ug-search-ic { position: absolute; left: 13px; top: 50%; transform: translateY(-50%); color: #94a3b8; font-size: 0.88rem; transition: color 0.3s; z-index: 2; }
        .ug-search-w:focus-within .ug-search-ic { color: #0B3D91; }
        .ug-search {
          width: 100%; padding: 11px 14px 11px 38px;
          background: rgba(240,244,251,0.5); border: 1.5px solid #e2e8f0;
          border-radius: 12px; color: #0d1b2a; font-size: 0.84rem; font-weight: 500;
          outline: none; transition: all 0.3s; font-family: inherit;
        }
        .ug-search::placeholder { color: #94a3b8; }
        .ug-search:focus { border-color: #0B3D91; box-shadow: 0 0 0 3px rgba(11,61,145,0.08); }

        /* TABLE */
        .ug-tw { border-radius: 13px; overflow: hidden; border: 1px solid #e2e8f0; }
        .ug-ts { max-height: 500px; overflow-y: auto; }
        .ug-tbl { width: 100%; border-collapse: separate; border-spacing: 0; }
        .ug-tbl thead { position: sticky; top: 0; z-index: 5; }
        .ug-tbl th {
          padding: 11px 14px; font-size: 0.6rem; font-weight: 700;
          text-transform: uppercase; letter-spacing: 0.1em;
          color: #64748b; border-bottom: 2px solid #e2e8f0;
          background: #eef3fb; white-space: nowrap; text-align: left;
        }
        .ug-tbl td {
          padding: 11px 14px; font-size: 0.8rem; color: #374151;
          border-bottom: 1px solid #f1f5f9; vertical-align: middle;
        }
        .ug-tbl tbody tr { transition: all 0.2s; cursor: pointer; }
        .ug-tbl tbody tr:hover { background: rgba(11,61,145,0.04); }
        .ug-tbl tbody tr:last-child td { border-bottom: none; }

        .ug-tag {
          display: inline-flex; align-items: center; padding: 2px 8px; border-radius: 6px;
          font-size: 0.66rem; font-weight: 650; border: 1px solid transparent; white-space: nowrap;
        }
        .ug-tag-b { background: rgba(11,61,145,0.1); color: #0B3D91; border-color: rgba(11,61,145,0.18); }
        .ug-tag-g { background: rgba(22,163,74,0.1); color: #16a34a; border-color: rgba(22,163,74,0.18); }
        .ug-tag-a { background: rgba(217,119,6,0.1); color: #d97706; border-color: rgba(217,119,6,0.18); }
        .ug-tag-r { background: rgba(220,38,38,0.08); color: #dc2626; border-color: rgba(220,38,38,0.15); }
        .ug-tag-c { background: rgba(3,105,161,0.1); color: #0369a1; border-color: rgba(3,105,161,0.18); }
        .ug-tag-p { background: rgba(11,61,145,0.1); color: #0B3D91; border-color: rgba(11,61,145,0.18); }

        /* ACTION BTNS */
        .ug-acts { display: flex; gap: 4px; }
        .ug-act {
          width: 28px; height: 28px; border-radius: 7px; border: 1.5px solid;
          background: transparent; display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all 0.25s; font-size: 0.72rem;
        }
        .ug-act:hover { transform: translateY(-1px); }
        .ug-act.v { border-color: rgba(3,105,161,0.2); color: #0369a1; }
        .ug-act.v:hover { background: rgba(3,105,161,0.08); }
        .ug-act.e { border-color: rgba(11,61,145,0.2); color: #0B3D91; }
        .ug-act.e:hover { background: rgba(11,61,145,0.08); }
        .ug-act.d { border-color: rgba(220,38,38,0.2); color: #dc2626; }
        .ug-act.d:hover { background: rgba(220,38,38,0.08); }

        /* MOBILE CARDS */
        .ug-cards { display: none; }
        .ug-card {
          background: #ffffff; border: 1px solid #e2e8f0;
          border-radius: 14px; padding: 14px; margin-bottom: 8px;
          transition: all 0.3s; animation: ugUp 0.3s ease both;
        }
        .ug-card:active { background: rgba(11,61,145,0.03); }
        .ug-card-h { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 10px; }
        .ug-card-n { font-weight: 700; color: #0d1b2a; font-size: 0.9rem; margin-bottom: 3px; }
        .ug-card-r { display: flex; justify-content: space-between; padding: 5px 0; border-bottom: 1px solid #f1f5f9; font-size: 0.76rem; }
        .ug-card-r:last-child { border-bottom: none; }
        .ug-card-rl { color: #64748b; font-weight: 500; }
        .ug-card-rv { color: #0d1b2a; font-weight: 600; text-align: right; }
        .ug-card-acts { display: flex; gap: 6px; justify-content: flex-end; margin-top: 10px; padding-top: 8px; border-top: 1px solid #f1f5f9; }
        .ug-card-exp { text-align: center; padding: 4px; color: #94a3b8; font-size: 0.65rem; cursor: pointer; }

        /* DETAIL MODAL */
        .ug-overlay {
          position: fixed; inset: 0; background: rgba(0,0,0,0.72);
          backdrop-filter: blur(6px); z-index: 1000;
          display: flex; align-items: center; justify-content: center;
          padding: 14px; animation: ugUp 0.2s ease;
        }
        .ug-modal {
          background: #ffffff;
          border: 1px solid #e2e8f0; border-radius: 20px;
          width: 100%; max-width: 720px; max-height: 88vh; overflow-y: auto;
          animation: ugScale 0.3s ease;
          box-shadow: 0 20px 70px rgba(0,0,0,0.35);
        }
        .ug-modal-head {
          padding: 18px 22px; border-bottom: 1px solid #e2e8f0;
          display: flex; align-items: center; justify-content: space-between;
          position: sticky; top: 0; background: #ffffff;
          backdrop-filter: blur(10px); z-index: 5; border-radius: 20px 20px 0 0;
        }
        .ug-modal-t { font-size: 1.08rem; font-weight: 800; color: #0d1b2a; display: flex; align-items: center; gap: 9px; }
        .ug-modal-x {
          width: 34px; height: 34px; border-radius: 10px;
          border: 1px solid #e2e8f0; background: #eef3fb;
          color: #64748b; cursor: pointer; display: flex;
          align-items: center; justify-content: center; transition: all 0.2s; font-size: 0.9rem;
        }
        .ug-modal-x:hover { color: #0d1b2a; border-color: #0B3D91; }
        .ug-modal-body { padding: 22px; }
        .ug-modal-foot {
          padding: 14px 22px; border-top: 1px solid #e2e8f0;
          display: flex; gap: 8px; justify-content: flex-end;
        }

        .ug-detail-section { margin-bottom: 20px; }
        .ug-detail-section-title {
          font-size: 0.68rem; font-weight: 700; color: #64748b;
          text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 10px;
          padding-bottom: 6px; border-bottom: 1px solid #f1f5f9;
          display: flex; align-items: center; gap: 7px;
        }
        .ug-detail-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
        .ug-detail-item {
          padding: 10px 12px; background: #f7f9fc;
          border: 1px solid #f1f5f9; border-radius: 10px;
        }
        .ug-detail-lbl { font-size: 0.62rem; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 2px; }
        .ug-detail-val { font-size: 0.88rem; font-weight: 600; color: #0d1b2a; }

        /* EMPTY / LOADER */
        .ug-empty { text-align: center; padding: 44px 16px; }
        .ug-empty-ic {
          width: 60px; height: 60px; border-radius: 16px;
          background: rgba(11,61,145,0.06); border: 1px solid rgba(11,61,145,0.12);
          display: inline-flex; align-items: center; justify-content: center;
          font-size: 1.4rem; color: #0B3D91; margin-bottom: 12px;
          animation: ugFloat 3s ease-in-out infinite;
        }
        .ug-loader { display: flex; gap: 5px; justify-content: center; padding: 44px; }
        .ug-loader span { width: 9px; height: 9px; border-radius: 50%; background: #0B3D91; animation: ugDot 1.4s infinite ease-in-out both; }
        .ug-loader span:nth-child(1) { animation-delay: -0.32s; }
        .ug-loader span:nth-child(2) { animation-delay: -0.16s; }

        .ug-footer { text-align: center; margin-top: 28px; padding-bottom: 14px; color: #94a3b8; font-size: 0.68rem; }

        /* RESPONSIVE */
        @media (max-width: 1024px) { .ug-stats { grid-template-columns: repeat(2, 1fr); } .ug-g4 { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 767px) {
          .ug-wrap { padding: 12px 10px 28px; }
          .ug-dtbl { display: none !important; }
          .ug-cards { display: block !important; }
          .ug-g2, .ug-g3, .ug-g4 { grid-template-columns: 1fr; }
          .ug-toggle { width: 100%; }
          .ug-toggle-btn { flex: 1; justify-content: center; font-size: 0.78rem; }
          .ug-btn-row { flex-direction: column; }
          .ug-btn { width: 100%; justify-content: center; }
          .ug-detail-grid { grid-template-columns: 1fr; }
          .ug-modal { border-radius: 16px; max-height: 85vh; }
          .ug-modal-body { padding: 16px; }
          .ug-modal-foot { flex-direction: column; }
          .ug-modal-foot .ug-btn { width: 100%; justify-content: center; }
        }
        @media (max-width: 576px) {
          .ug-stat { padding: 12px 8px; border-radius: 12px; }
          .ug-stat-ic { width: 32px; height: 32px; font-size: 0.85rem; margin-bottom: 6px; }
          .ug-stat-v { font-size: 1.1rem; }
          .ug-stat-l { font-size: 0.48rem; }
          .ug-stats { gap: 6px; }
          .ug-glass { border-radius: 14px; }
          .ug-glass-body { padding: 12px; }
          .ug-inp, .ug-sel, .ug-search { font-size: 0.82rem; border-radius: 10px; }
          .ug-btn { padding: 10px 18px; font-size: 0.8rem; border-radius: 10px; }
        }
        @media (max-width: 400px) { .ug-stat-v { font-size: 0.95rem; } .ug-stats { gap: 5px; } }
        @supports (-webkit-touch-callout: none) { .ug-app { min-height: 100dvh; } .ug-inp, .ug-sel, .ug-search { font-size: 16px; } }
        @media (hover: none) and (pointer: coarse) { .ug-stat:hover { transform: none; box-shadow: none; } .ug-act:hover { transform: none; } }
      `}</style>

      <div className="ug-root">
        <div className="ug-app">
          <div className="ug-layer">
            <div className="ug-wrap">

              {/* Header */}
              <div className="ug-header">
                <div className="ug-chip"><i className="bi bi-house-heart-fill"></i> Sisitemu y'Iyandikisha</div>
                <h1 className="ug-title">Urugo n'Umuryango</h1>
                <p className="ug-sub">Andika amakuru yose y'urugo mu buryo bworoshye kandi bwizewe</p>
              </div>

              {/* Stats */}
              <div className="ug-stats">
                <div className="ug-stat c1">
                  <div className="ug-stat-ic" style={{ background: 'rgba(11,61,145,0.1)', color: '#0B3D91' }}><i className="bi bi-house-door-fill"></i></div>
                  <div className="ug-stat-v">{records.length}</div>
                  <div className="ug-stat-l">Ingo zose</div>
                </div>
                <div className="ug-stat c2">
                  <div className="ug-stat-ic" style={{ background: 'rgba(3,105,161,0.1)', color: '#0369a1' }}><i className="bi bi-people-fill"></i></div>
                  <div className="ug-stat-v">{records.reduce((s, r) => s + (parseInt(r.umubare_abagize) || 0), 0)}</div>
                  <div className="ug-stat-l">Abagize</div>
                </div>
                <div className="ug-stat c3">
                  <div className="ug-stat-ic" style={{ background: 'rgba(217,119,6,0.1)', color: '#d97706' }}><i className="bi bi-person-wheelchair"></i></div>
                  <div className="ug-stat-v">{records.filter(r => parseInt(r.abafite_ubumuga) > 0).length}</div>
                  <div className="ug-stat-l">Ubumuga</div>
                </div>
                <div className="ug-stat c4">
                  <div className="ug-stat-ic" style={{ background: 'rgba(220,38,38,0.1)', color: '#dc2626' }}><i className="bi bi-heart-pulse-fill"></i></div>
                  <div className="ug-stat-v">{records.reduce((s, r) => s + (parseInt(r.abagore_batwite) || 0), 0)}</div>
                  <div className="ug-stat-l">Batwite</div>
                </div>
              </div>

              {/* Toggle */}
              <div className="ug-toggle-wrap">
                <div className="ug-toggle">
                  <button className={`ug-toggle-btn ${activeSection === 'form' ? 'active' : ''}`} onClick={() => setActiveSection('form')}>
                    <i className="bi bi-pencil-square"></i> {editId ? 'Hindura' : 'Iyandikisha'}
                  </button>
                  <button className={`ug-toggle-btn ${activeSection === 'records' ? 'active' : ''}`} onClick={() => setActiveSection('records')}>
                    <i className="bi bi-table"></i> Amakuru <span className="ug-badge">{records.length}</span>
                  </button>
                </div>
              </div>

              {/* Alerts */}
              {success && (
                <div className="ug-alert ug-alert-ok">
                  <div className="ug-alert-ic" style={{ background: 'rgba(22,163,74,0.1)' }}><i className="bi bi-check-lg"></i></div>
                  {success}
                  <button className="ug-alert-x" onClick={() => setSuccess(null)}>✕</button>
                </div>
              )}
              {error && (
                <div className="ug-alert ug-alert-err">
                  <div className="ug-alert-ic" style={{ background: 'rgba(220,38,38,0.1)' }}><i className="bi bi-x-lg"></i></div>
                  {error}
                  <button className="ug-alert-x" onClick={() => setError(null)}>✕</button>
                </div>
              )}

              {/* ═══ FORM ═══ */}
              {activeSection === 'form' && (
                <div className="ug-glass" style={{ animation: 'ugScale 0.4s ease' }}>
                  <div className="ug-glass-body">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24, paddingBottom: 18, borderBottom: '1px solid rgba(11,61,145,0.04)' }}>
                      <div style={{ width: 48, height: 48, borderRadius: 14, background: 'linear-gradient(135deg, #0B3D91, #093278)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', color: '#ffffff', flexShrink: 0, boxShadow: '0 4px 16px rgba(11,61,145,0.25)' }}>
                        <i className={`bi bi-${editId ? 'pencil-square' : 'house-add-fill'}`}></i>
                      </div>
                      <div>
                        <div style={{ fontWeight: 800, color: '#0d1b2a', fontSize: '1.15rem' }}>{editId ? 'Hindura Urugo' : 'Fomu y\'Iyandikisha'}</div>
                        <div style={{ color: '#64748b', fontSize: '0.78rem' }}>Uzuza amakuru yose akenewe</div>
                      </div>
                      {editId && (
                        <button className="ug-btn ug-btn-g" style={{ marginLeft: 'auto', padding: '8px 14px', fontSize: '0.76rem' }}
                          onClick={() => { setFormData(initialFormData); setEditId(null); }}>
                          <i className="bi bi-x-lg"></i> Hagarika
                        </button>
                      )}
                    </div>

                    <form onSubmit={handleSubmit}>
                      {/* Location Section */}
                      <div className="ug-section">
                        <div className="ug-section-dot" style={{ background: 'rgba(59,130,246,0.1)', color: '#0369a1' }}><i className="bi bi-geo-alt-fill"></i></div>
                        <span className="ug-section-txt">Aho aherereye</span>
                      </div>
                      <div className="ug-grid ug-g3">
                        <div className="ug-field">
                          <label className="ug-label">Umudugudu</label>
                          <div className="ug-iw">
                            <i className="bi bi-geo-alt ug-ii"></i>
                            <input className="ug-inp" name="umudugudu" value={formData.umudugudu} onChange={handleChange} placeholder="Umudugudu" />
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Isibo</label>
                          <div className="ug-iw">
                            <i className="bi bi-signpost ug-ii"></i>
                            <input className="ug-inp" name="isibo" value={formData.isibo} onChange={handleChange} placeholder="Isibo" />
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Nimero y'urugo<span className="ug-req">*</span></label>
                          <div className="ug-iw">
                            <i className="bi bi-hash ug-ii"></i>
                            <input className="ug-inp" name="nimero_urugo" value={formData.nimero_urugo} onChange={handleChange} placeholder="URG-001" required />
                          </div>
                        </div>
                      </div>

                      {/* Head of Household Section */}
                      <div className="ug-section">
                        <div className="ug-section-dot" style={{ background: 'rgba(11,61,145,0.1)', color: '#0B3D91' }}><i className="bi bi-person-fill"></i></div>
                        <span className="ug-section-txt">Umukuru w'urugo</span>
                      </div>
                      <div className="ug-grid ug-g2">
                        <div className="ug-field">
                          <label className="ug-label">Amazina<span className="ug-req">*</span></label>
                          <div className="ug-iw">
                            <i className="bi bi-person ug-ii"></i>
                            <input className="ug-inp" name="amazina_umukuru" value={formData.amazina_umukuru} onChange={handleChange} placeholder="Amazina yuzuye" required />
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Uburyo bw'inzu</label>
                          <div className="ug-iw">
                            <i className="bi bi-house-door ug-ii"></i>
                            <select className="ug-sel" name="uburyo_bwinzu" value={formData.uburyo_bwinzu} onChange={handleChange}>
                              <option value="Iyabo">Iyabo</option>
                              <option value="Ikodeshejwe">Ikodeshejwe</option>
                              <option value="Iryakodeshejwe_na_Leta">Iryakodeshejwe na Leta</option>
                            </select>
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Icyiciro cy'Ubudehe</label>
                          <div className="ug-iw">
                            <i className="bi bi-layers ug-ii"></i>
                            <select className="ug-sel" name="icyiciro_ubudehe" value={formData.icyiciro_ubudehe} onChange={handleChange}>
                              <option value="">-- Hitamo --</option>
                              <option value="Arakize">Arakize (Wealthy)</option>
                              <option value="Arifashije">Arifashije (Self-sufficient)</option>
                              <option value="Arakennye">Arakennye (Poor)</option>
                            </select>
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Umukono / Igikumwe</label>
                          <div className="ug-iw">
                            <i className="bi bi-fingerprint ug-ii"></i>
                            <input className="ug-inp" name="umukono_cyangwa_igikumwe" value={formData.umukono_cyangwa_igikumwe} onChange={handleChange} placeholder="Umukono" />
                          </div>
                        </div>
                      </div>

                      {/* Members Section */}
                      <div className="ug-section">
                        <div className="ug-section-dot" style={{ background: 'rgba(3,105,161,0.1)', color: '#0369a1' }}><i className="bi bi-people-fill"></i></div>
                        <span className="ug-section-txt">Abagize urugo</span>
                      </div>
                      <div className="ug-grid ug-g4">
                        <div className="ug-field">
                          <label className="ug-label">Abagize bose</label>
                          <div className="ug-iw">
                            <i className="bi bi-people ug-ii"></i>
                            <input className="ug-inp" type="number" name="umubare_abagize" value={formData.umubare_abagize} onChange={handleChange} min="0" />
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Abana</label>
                          <div className="ug-iw">
                            <i className="bi bi-emoji-smile ug-ii"></i>
                            <input className="ug-inp" type="number" name="abana_bari_murugo" value={formData.abana_bari_murugo} onChange={handleChange} min="0" />
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Abakuru</label>
                          <div className="ug-iw">
                            <i className="bi bi-person-fill-gear ug-ii"></i>
                            <input className="ug-inp" type="number" name="abageze_mu_zabukuru" value={formData.abageze_mu_zabukuru} onChange={handleChange} min="0" />
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Ubumuga</label>
                          <div className="ug-iw">
                            <i className="bi bi-person-wheelchair ug-ii"></i>
                            <input className="ug-inp" type="number" name="abafite_ubumuga" value={formData.abafite_ubumuga} onChange={handleChange} min="0" />
                          </div>
                        </div>
                      </div>

                      {/* Health Section */}
                      <div className="ug-section">
                        <div className="ug-section-dot" style={{ background: 'rgba(220,38,38,0.1)', color: '#dc2626' }}><i className="bi bi-heart-pulse-fill"></i></div>
                        <span className="ug-section-txt">Ubuzima n'imibereho</span>
                      </div>
                      <div className="ug-grid ug-g4">
                        <div className="ug-field">
                          <label className="ug-label">Abagore batwite</label>
                          <div className="ug-iw">
                            <i className="bi bi-heart-fill ug-ii"></i>
                            <input className="ug-inp" type="number" name="abagore_batwite" value={formData.abagore_batwite} onChange={handleChange} min="0" />
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Abana bakingiwe</label>
                          <div className="ug-iw">
                            <i className="bi bi-shield-check ug-ii"></i>
                            <input className="ug-inp" type="number" name="abana_bakingiwe" value={formData.abana_bakingiwe} onChange={handleChange} min="0" />
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Imibereho</label>
                          <div className="ug-iw">
                            <i className="bi bi-bar-chart ug-ii"></i>
                            <select className="ug-sel" name="icyiciro_imibereho" value={formData.icyiciro_imibereho} onChange={handleChange}>
                              <option value="Arakize">Arakize</option>
                              <option value="Arifashije">Arifashije</option>
                              <option value="Arakennye">Arakennye</option>
                            </select>
                          </div>
                        </div>
                        <div className="ug-field">
                          <label className="ug-label">Ubwishingizi</label>
                          <div className="ug-iw">
                            <i className="bi bi-shield-plus ug-ii"></i>
                            <input className="ug-inp" name="ubwishingizi_ubuzima" value={formData.ubwishingizi_ubuzima} onChange={handleChange} placeholder="Mutuelle, RSSB..." />
                          </div>
                        </div>
                      </div>
                      <div className="ug-grid ug-g2" style={{ marginBottom: 24 }}>
                        <div className="ug-field">
                          <label className="ug-label">Ahabwa inkunga</label>
                          <div className="ug-iw">
                            <i className="bi bi-gift ug-ii"></i>
                            <input className="ug-inp" name="ahabwa_inkunga" value={formData.ahabwa_inkunga} onChange={handleChange} placeholder="VUP, Girinka..." />
                          </div>
                        </div>
                      </div>

                      {/* Checkboxes Section */}
                      <div className="ug-section">
                        <div className="ug-section-dot" style={{ background: 'rgba(22,163,74,0.1)', color: '#16a34a' }}><i className="bi bi-check2-square"></i></div>
                        <span className="ug-section-txt">Ibimenyetso</span>
                      </div>
                      <div className="ug-grid ug-g4" style={{ marginBottom: 20 }}>
                        <label className="ug-chk">
                          <input type="checkbox" name="hari_indwara_zidakira" checked={formData.hari_indwara_zidakira} onChange={handleChange} />
                          <div className="ug-chk-box">✓</div>
                          <span className="ug-chk-txt">Indwara zidakira</span>
                        </label>
                        <label className="ug-chk">
                          <input type="checkbox" name="hari_amakimbirane" checked={formData.hari_amakimbirane} onChange={handleChange} />
                          <div className="ug-chk-box">✓</div>
                          <span className="ug-chk-txt">Amakimbirane</span>
                        </label>
                        <label className="ug-chk">
                          <input type="checkbox" name="yitabira_amarondo" checked={formData.yitabira_amarondo} onChange={handleChange} />
                          <div className="ug-chk-box">✓</div>
                          <span className="ug-chk-txt">Yitabira amarondo</span>
                        </label>
                        <label className="ug-chk" style={formData.yemeye_amakuru ? { borderColor: 'rgba(22,163,74,0.25)', background: 'rgba(22,163,74,0.04)' } : {}}>
                          <input type="checkbox" name="yemeye_amakuru" checked={formData.yemeye_amakuru} onChange={handleChange} />
                          <div className="ug-chk-box">✓</div>
                          <span className="ug-chk-txt">Yemeye amakuru <span style={{ color: '#dc2626' }}>*</span></span>
                        </label>
                      </div>

                      {/* Submit Buttons */}
                      <div className="ug-btn-row">
                        <button type="submit" className="ug-btn ug-btn-p" disabled={loading}>
                          {loading ? (
                            <>
                              <div className="spinner-border spinner-border-sm" style={{ width: 16, height: 16, borderWidth: 2, borderColor: 'rgba(255,255,255,0.35)', borderTopColor: '#ffffff' }}></div>
                              Tegereza...
                            </>
                          ) : (
                            <>
                              <i className={`bi bi-${editId ? 'check-lg' : 'plus-lg'}`}></i>
                              {editId ? 'Hindura Urugo' : 'Andika Urugo'}
                            </>
                          )}
                        </button>
                        <button type="button" className="ug-btn ug-btn-g" onClick={() => { setFormData(initialFormData); setEditId(null); }}>
                          <i className="bi bi-arrow-counterclockwise"></i> Siba
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              {/* ═══ RECORDS ═══ */}
              {activeSection === 'records' && (
                <div className="ug-glass" style={{ animation: 'ugScale 0.4s ease' }}>
                  <div className="ug-glass-body">
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 20, paddingBottom: 16, borderBottom: '1px solid rgba(11,61,145,0.04)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 42, height: 42, borderRadius: 12, background: 'rgba(11,61,145,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', color: '#0B3D91' }}><i className="bi bi-table"></i></div>
                        <div>
                          <div style={{ fontWeight: 800, color: '#0d1b2a', fontSize: '1.05rem' }}>Ingo zanditswe</div>
                          <div style={{ color: '#64748b', fontSize: '0.75rem' }}>{filteredRecords.length} mu {records.length}</div>
                        </div>
                      </div>
                      <div className="ug-search-w">
                        <i className="bi bi-search ug-search-ic"></i>
                        <input className="ug-search" placeholder="Shakisha..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
                      </div>
                    </div>

                    {loading ? (
                      <div className="ug-loader"><span></span><span></span><span></span></div>
                    ) : filteredRecords.length === 0 ? (
                      <div className="ug-empty">
                        <div className="ug-empty-ic"><i className="bi bi-house-slash"></i></div>
                        <h5 style={{ color: '#374151', fontWeight: 700 }}>Nta makuru</h5>
                        <p style={{ color: '#94a3b8', fontSize: '0.82rem' }}>
                          {searchTerm ? 'Hindura gushakisha' : 'Tangira wandike urugo'}
                        </p>
                      </div>
                    ) : (
                      <>
                        {/* Desktop Table */}
                        <div className="ug-dtbl">
                          <div className="ug-tw">
                            <div className="ug-ts">
                              <table className="ug-tbl">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Nimero</th>
                                    <th>Umukuru</th>
                                    <th>Umudugudu</th>
                                    <th>Ubudehe</th>
                                    <th>Abagize</th>
                                    <th>Abana</th>
                                    <th>Ubumuga</th>
                                    <th>Batwite</th>
                                    <th>Inzu</th>
                                    <th>Imibereho</th>
                                    <th>Inkunga</th>
                                    <th>Ibikorwa</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {filteredRecords.map((r, i) => (
                                    <tr key={r.id} style={{ animation: `ugSlide 0.3s ease ${i * 0.03}s both` }}>
                                      <td style={{ color: '#94a3b8' }}>{i + 1}</td>
                                      <td><span className="ug-tag ug-tag-b">{r.nimero_urugo}</span></td>
                                      <td style={{ fontWeight: 700, color: '#0d1b2a' }}>{r.amazina_umukuru}</td>
                                      <td>{r.umudugudu || '—'}</td>
                                      <td>{r.icyiciro_ubudehe ? <span className="ug-tag ug-tag-a">{r.icyiciro_ubudehe}</span> : '—'}</td>
                                      <td style={{ fontWeight: 700, color: '#0B3D91' }}>{r.umubare_abagize || 0}</td>
                                      <td>{r.abana_bari_murugo || 0}</td>
                                      <td>{parseInt(r.abafite_ubumuga) > 0 ? <span className="ug-tag ug-tag-a">{r.abafite_ubumuga}</span> : '0'}</td>
                                      <td>{parseInt(r.abagore_batwite) > 0 ? <span className="ug-tag ug-tag-r">{r.abagore_batwite}</span> : '0'}</td>
                                      <td><span className="ug-tag ug-tag-p">{(r.uburyo_bwinzu || '').replace(/_/g, ' ')}</span></td>
                                      <td><span className="ug-tag ug-tag-c">{r.icyiciro_imibereho || '—'}</span></td>
                                      <td>{r.ahabwa_inkunga || '—'}</td>
                                      <td>
                                        <div className="ug-acts">
                                          <button className="ug-act v" title="Reba byose" onClick={(e) => { e.stopPropagation(); setDetailRecord(r); }}><i className="bi bi-eye"></i></button>
                                          <button className="ug-act e" title="Hindura" onClick={(e) => { e.stopPropagation(); handleEdit(r); }}><i className="bi bi-pencil"></i></button>
                                          <button className="ug-act d" title="Siba" onClick={(e) => { e.stopPropagation(); handleDelete(r.id); }}><i className="bi bi-trash3"></i></button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        {/* Mobile Cards */}
                        <div className="ug-cards">
                          {filteredRecords.map((r, i) => {
                            const isExp = expandedRow === r.id;
                            return (
                              <div key={r.id} className="ug-card" style={{ animationDelay: `${i * 0.03}s` }} onClick={() => setExpandedRow(isExp ? null : r.id)}>
                                <div className="ug-card-h">
                                  <div>
                                    <div className="ug-card-n">{r.amazina_umukuru}</div>
                                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                      <span className="ug-tag ug-tag-b">{r.nimero_urugo}</span>
                                      {r.icyiciro_ubudehe && <span className="ug-tag ug-tag-a">{r.icyiciro_ubudehe}</span>}
                                    </div>
                                  </div>
                                  <div style={{ textAlign: 'right' }}>
                                    <div style={{ fontWeight: 800, color: '#0B3D91', fontSize: '1.2rem', lineHeight: 1 }}>{r.umubare_abagize || 0}</div>
                                    <div style={{ color: '#94a3b8', fontSize: '0.6rem' }}>abagize</div>
                                  </div>
                                </div>
                                <div className="ug-card-r"><span className="ug-card-rl">Umudugudu</span><span className="ug-card-rv">{r.umudugudu || '—'}</span></div>
                                <div className="ug-card-r"><span className="ug-card-rl">Abana</span><span className="ug-card-rv">{r.abana_bari_murugo || 0}</span></div>
                                <div className="ug-card-r"><span className="ug-card-rl">Inzu</span><span className="ug-card-rv">{(r.uburyo_bwinzu || '').replace(/_/g, ' ')}</span></div>
                                {isExp && (
                                  <div style={{ animation: 'ugUp 0.25s ease' }}>
                                    <div className="ug-card-r"><span className="ug-card-rl">Isibo</span><span className="ug-card-rv">{r.isibo || '—'}</span></div>
                                    <div className="ug-card-r"><span className="ug-card-rl">Abakuru</span><span className="ug-card-rv">{r.abageze_mu_zabukuru || 0}</span></div>
                                    <div className="ug-card-r"><span className="ug-card-rl">Ubumuga</span><span className="ug-card-rv">{r.abafite_ubumuga || 0}</span></div>
                                    <div className="ug-card-r"><span className="ug-card-rl">Batwite</span><span className="ug-card-rv">{r.abagore_batwite || 0}</span></div>
                                    <div className="ug-card-r"><span className="ug-card-rl">Bakingiwe</span><span className="ug-card-rv">{r.abana_bakingiwe || 0}</span></div>
                                    <div className="ug-card-r"><span className="ug-card-rl">Imibereho</span><span className="ug-card-rv">{r.icyiciro_imibereho || '—'}</span></div>
                                    <div className="ug-card-r"><span className="ug-card-rl">Ubwishingizi</span><span className="ug-card-rv">{r.ubwishingizi_ubuzima || '—'}</span></div>
                                    <div className="ug-card-r"><span className="ug-card-rl">Inkunga</span><span className="ug-card-rv">{r.ahabwa_inkunga || '—'}</span></div>
                                    <div className="ug-card-r"><span className="ug-card-rl">Indwara zidakira</span><span className="ug-card-rv">{boolLabel(r.hari_indwara_zidakira)}</span></div>
                                    <div className="ug-card-r"><span className="ug-card-rl">Amakimbirane</span><span className="ug-card-rv">{boolLabel(r.hari_amakimbirane)}</span></div>
                                    <div className="ug-card-r"><span className="ug-card-rl">Amarondo</span><span className="ug-card-rv">{boolLabel(r.yitabira_amarondo)}</span></div>
                                    <div className="ug-card-acts" onClick={e => e.stopPropagation()}>
                                      <button className="ug-act v" onClick={() => setDetailRecord(r)}><i className="bi bi-eye"></i></button>
                                      <button className="ug-act e" onClick={() => handleEdit(r)}><i className="bi bi-pencil"></i></button>
                                      <button className="ug-act d" onClick={() => handleDelete(r.id)}><i className="bi bi-trash3"></i></button>
                                    </div>
                                  </div>
                                )}
                                <div className="ug-card-exp"><i className={`bi bi-chevron-${isExp ? 'up' : 'down'}`}></i></div>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}

              {/* ═══ DETAIL MODAL ═══ */}
              {detailRecord && (
                <div className="ug-overlay" onClick={() => setDetailRecord(null)}>
                  <div className="ug-modal" onClick={e => e.stopPropagation()}>
                    <div className="ug-modal-head">
                      <div className="ug-modal-t">
                        <i className="bi bi-house-door-fill" style={{ color: '#0B3D91' }}></i>
                        Amakuru yose y'Urugo
                      </div>
                      <button className="ug-modal-x" onClick={() => setDetailRecord(null)}>✕</button>
                    </div>
                    <div className="ug-modal-body">
                      {/* Header */}
                      <div style={{ textAlign: 'center', marginBottom: 22 }}>
                        <div style={{ width: 56, height: 56, borderRadius: 16, background: 'linear-gradient(135deg, rgba(11,61,145,0.12), rgba(11,61,145,0.12))', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem', color: '#0B3D91', marginBottom: 8 }}>
                          <i className="bi bi-house-heart-fill"></i>
                        </div>
                        <h3 style={{ fontWeight: 800, color: '#0d1b2a', fontSize: '1.15rem', margin: 0 }}>{detailRecord.amazina_umukuru}</h3>
                        <div style={{ display: 'flex', gap: 5, justifyContent: 'center', marginTop: 6 }}>
                          <span className="ug-tag ug-tag-b">{detailRecord.nimero_urugo}</span>
                          {detailRecord.icyiciro_ubudehe && <span className="ug-tag ug-tag-a">{detailRecord.icyiciro_ubudehe}</span>}
                        </div>
                      </div>

                      {/* Location Section */}
                      <div className="ug-detail-section">
                        <div className="ug-detail-section-title"><i className="bi bi-geo-alt-fill" style={{ color: '#0369a1' }}></i> Aho aherereye</div>
                        <div className="ug-detail-grid">
                          <DetailField icon="geo-alt" label="Umudugudu" value={detailRecord.umudugudu} color="#0369a1" />
                          <DetailField icon="signpost" label="Isibo" value={detailRecord.isibo} color="#0369a1" />
                          <DetailField icon="hash" label="Nimero y'urugo" value={detailRecord.nimero_urugo} color="#0B3D91" />
                          <DetailField icon="house-door" label="Uburyo bw'inzu" value={(detailRecord.uburyo_bwinzu || '').replace(/_/g, ' ')} color="#0B3D91" />
                        </div>
                      </div>

                      {/* Members Section */}
                      <div className="ug-detail-section">
                        <div className="ug-detail-section-title"><i className="bi bi-people-fill" style={{ color: '#0369a1' }}></i> Abagize urugo</div>
                        <div className="ug-detail-grid">
                          <DetailField icon="people" label="Abagize bose" value={detailRecord.umubare_abagize || 0} color="#0369a1" />
                          <DetailField icon="emoji-smile" label="Abana" value={detailRecord.abana_bari_murugo || 0} color="#d97706" />
                          <DetailField icon="person-fill-gear" label="Abakuru (Zabukuru)" value={detailRecord.abageze_mu_zabukuru || 0} color="#dc2626" />
                          <DetailField icon="person-wheelchair" label="Ubumuga" value={detailRecord.abafite_ubumuga || 0} color="#d97706" />
                        </div>
                      </div>

                      {/* Health Section */}
                      <div className="ug-detail-section">
                        <div className="ug-detail-section-title"><i className="bi bi-heart-pulse-fill" style={{ color: '#dc2626' }}></i> Ubuzima n'Imibereho</div>
                        <div className="ug-detail-grid">
                          <DetailField icon="heart-fill" label="Abagore batwite" value={detailRecord.abagore_batwite || 0} color="#dc2626" />
                          <DetailField icon="shield-check" label="Abana bakingiwe" value={detailRecord.abana_bakingiwe || 0} color="#16a34a" />
                          <DetailField icon="bar-chart" label="Imibereho" value={detailRecord.icyiciro_imibereho} color="#0B3D91" />
                          <DetailField icon="layers" label="Ubudehe" value={detailRecord.icyiciro_ubudehe || '—'} color="#d97706" />
                          <DetailField icon="shield-plus" label="Ubwishingizi" value={detailRecord.ubwishingizi_ubuzima} color="#0369a1" />
                          <DetailField icon="gift" label="Inkunga" value={detailRecord.ahabwa_inkunga} color="#0B3D91" />
                        </div>
                      </div>

                      {/* Booleans Section */}
                      <div className="ug-detail-section">
                        <div className="ug-detail-section-title"><i className="bi bi-check2-square" style={{ color: '#16a34a' }}></i> Ibimenyetso</div>
                        <div className="ug-detail-grid">
                          <DetailField icon="virus" label="Indwara zidakira" value={boolLabel(detailRecord.hari_indwara_zidakira)} color="#dc2626" />
                          <DetailField icon="exclamation-triangle" label="Amakimbirane" value={boolLabel(detailRecord.hari_amakimbirane)} color="#d97706" />
                          <DetailField icon="calendar-check" label="Yitabira amarondo" value={boolLabel(detailRecord.yitabira_amarondo)} color="#16a34a" />
                          <DetailField icon="check-circle" label="Yemeye amakuru" value={boolLabel(detailRecord.yemeye_amakuru)} color="#0B3D91" />
                          <DetailField icon="fingerprint" label="Umukono / Igikumwe" value={detailRecord.umukono_cyangwa_igikumwe} color="#0B3D91" />
                          <DetailField icon="clock" label="Itariki" value={detailRecord.created_at ? new Date(detailRecord.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'} color="#64748b" />
                        </div>
                      </div>
                    </div>

                    <div className="ug-modal-foot">
                      <button className="ug-btn ug-btn-g" onClick={() => setDetailRecord(null)}>Funga</button>
                      <button className="ug-btn ug-btn-p" onClick={() => handleEdit(detailRecord)}>
                        <i className="bi bi-pencil"></i> Hindura
                      </button>
                      <button className="ug-btn ug-btn-d" onClick={() => handleDelete(detailRecord.id)}>
                        <i className="bi bi-trash3"></i> Siba
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="ug-footer">
                <i className="bi bi-shield-lock-fill" style={{ marginRight: 5 }}></i>
                Amakuru yose arindwa — akoreshwa ku buryo bw'amategeko
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UrugoUmuryango;